var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-full bg-gray-300 text-white text-center flex items-center font-semibold tracking-wider mr-4",class:[
    _vm.size === 10 ? 'h-10 w-10' : ("w-" + _vm.size + " h-" + _vm.size),
    _vm.size <= 10 ? 'text-xl' : _vm.size <= 10 ? 'text-2xl' : 'text-3xl'
  ]},[_c('div',{staticClass:"flex-1"},[_vm._v(_vm._s(_vm.initials))])])}
var staticRenderFns = []

export { render, staticRenderFns }